module.exports = __webpack_public_path__ + "static/media/categories-logo-semrush.4d52bc35.svg";